<template>
    <div id="app">
        <main-header></main-header>
        <main>
            <a-row class="content">
                <a-col :md="14" :sm="0" :xs="0">
                    <h2>欢迎来到H5魔塔游戏世界</h2>
                    <img src="/assets/login.png">
                </a-col>
                <a-col :md="{ span: 8, offset: 0 }" :sm="{ span: 12, offset: 6 }" :xs="{ span: 24, offset: 0}">
                    <a-card class="form-container">
                        <a-form-model :model="form" :rules="rules" ref="registerForm">
                            <a-form-model-item class="formitem" prop="qq">
                                <a-input v-model="form.qq" placeholder="请输入您的qq号">
                                    <a-icon slot="addonBefore" type="qq" />
                                </a-input>
                            </a-form-model-item>
                            <a-form-model-item class="formitem" prop="username">
                                <a-input v-model="form.username" placeholder="请输入用户名（不超过20字）">
                                    <a-icon slot="addonBefore" type="user" />
                                </a-input>
                            </a-form-model-item>
                            <a-form-model-item class="formitem" prop="password">
                                <a-input v-model="form.password" type="password" placeholder="请输入密码">
                                    <a-icon slot="addonBefore" type="unlock" />
                                </a-input>
                            </a-form-model-item>
                            <a-form-model-item class="formitem" prop="confirmPassword">
                                <a-input v-model="form.confirmPassword" type="password" placeholder="请再次输入密码">
                                    <a-icon slot="addonBefore" type="unlock" />
                                </a-input>
                            </a-form-model-item>
                        </a-form-model>
                        <div>
                            <a-button type="primary" @click="register" :loading="isRegistering" class="register-button">注册</a-button>
                        </div>
                        <div class="carditem">
                            已有账号? <a class="el-link" href="/user/login.html">去登录</a>
                        </div>
                    </a-card>
                </a-col>
            </a-row>
        </main>
        <div class="bar"></div>
        <Footer></Footer>
    </div>
</template>

<script>
import MainHeader from '@/components/MainHeader'
import Footer from '@/components/Footer'
import axios from 'axios'
import { createFormData, getReason } from '../../utils/utils'
import { hex_md5 } from '../../utils/md5'

export default {
    data() {
        return {
        form: {
            qq: "",
            username: "",
            password: "",
            confirmPassword: "",
        },
        isRegistering: false,
        rules: {
            qq: [
                { validator: (rule, value, callback) => {
                    if (!/^[1-9]\d{5,11}$/.test(value)) {
                        callback(new Error("请输入有效的qq号"));
                    } else {
                        callback();
                    }
                }, trigger: 'change' },
                { required: true, message: '请输入qq号' }
            ],
            username: [
                { validator: (rule, value, callback) => {
                    if (value.length > 20) {
                        callback(new Error("用户名最长为20个字符"));
                    } else {
                        callback();
                    }
                }, trigger: 'change' },
                { required: true, message: '请输入用户名' }
            ],
            password: [
                { validator: (rule, value, callback) => {
                    if (value.length < 8) {
                        callback(new Error("密码不得少于8位"));
                    } else if (!/\d/.test(value) || !/[a-z]/.test(value) || !/[A-Z]/.test(value)) {
                        callback(new Error("密码必须包含数字和大小写字母"));
                    } else {
                        callback();
                    }
                }, trigger: 'change' },
                { required: true, message: '请输入密码' }
            ],
            confirmPassword: [
                { required: true, message: '请再次输入密码' },
                { validator: (rule, value, callback) => {
                    if (value !== this.form.password) {
                        callback(new Error("两次输入的密码不同"));
                    } else {
                        callback();
                    }
                }, trigger: 'blur' },
            ],
        }
        }
    },
    methods: {
        register() {
            this.$refs.registerForm.validate(async(valid) => {
                if (valid) {
                    this.isRegistering = true;
                    const { qq, username, password } = this.form;
                    try {
                        const { data } = await axios.post("/backend/user/register.php", createFormData({
                            qq, username, password: hex_md5(password)
                        }));
                        if (data.code == 0) {
                            this.$success({
                                title: '注册成功',
                                content: h => (
                                    <p class="message">欢迎加入H5魔塔广场, 您的用户ID是<b>{ data.id }</b>, 请记住此ID, 网站需要通过ID或QQ号进行登录, 为了避免忘记, 可以现在将记住密码中的用户名改为ID或者QQ号</p>
                                ),
                                okText: '进入广场',
                                onOk() {
                                    window.location.assign("/");
                                }
                            });
                        } else {
                            const reason = getReason(data, {
                                '-2': 'qq或用户名已被注册',
                            });
                            this.$message.error(`注册失败 ${ reason }`);
                        }
                    } catch (e) {
                        this.$message.error(`注册失败: ${ e }`);
                    } finally {
                        this.isRegistering = false;
                    }
                }
            })
        }
    },
    components: {
        MainHeader, Footer,
    }
}
</script>

<style lang="less">
html, body {
    height: 100%;
    width: 100%;
    margin: 0;
}
#app {
    font-family: Avenir, Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    text-align: center;
    color: #2c3e50;
    min-height: 100%;
    display: flex;
    flex-direction: column;
    cursor: default;
    main {
        background-color: #2C8CF0;
        flex-grow: 1;
        display: flex;
        flex-direction: column;
    }
}
.content {
    margin-top: auto;
    h2 {
        color: white;
    }
    .form-container {
        min-width: 320px;
        max-width: 580px;
    }
    .ant-form-item {
        margin-bottom: 10px;
    }
    .ant-input-group-addon {
        background-color: #2C8CF0;
        color: white;
    }
    .register-button span {
        margin: 0px 40px;
    }
    .ant-form.ant-form-horizontal {
        margin-top: 10px;
    }
    .carditem {
        margin-top: 15px;
    }
}
.bar {
    background-color: #EFF2F9;
    height: 100px;
}
</style>
